import {create} from 'zustand';

const store = create((set) => ({
  quizForUserActionEnabled: false,
  companyLocale: "pl",
  supportedLocales: ["pl"],
  userActionsToQuiz: [],
  setUserActionsToQuiz: (ua) => set({ userActionsToQuiz: ua }),
  setSupportedLocales: (locales) => set({ supportedLocales: locales }),
  setCompanyLocale: (cLocale) => set({ companyLocale: cLocale }),
  setQuizForUserActionEnabled: (boolVal) => set({ quizForUserActionEnabled: boolVal }), 
}));

export default store;